import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef } from '@angular/core';
import {NgClassType, SrsNodeBaseDef} from "../../model/common.model";
import {ReflectedType, ReflectorService} from "../../services/reflector.service";
import {
  DatePipe,
  JsonPipe,
  NgClass,
  NgForOf,
  NgIf,
  NgSwitch,
  NgSwitchCase,
  NgSwitchDefault,
  NgTemplateOutlet
} from "@angular/common";
import {QuickPreviewPanelComponent} from "../quick-preview-panel/quick-preview-panel.component";
import {DataTableComponent} from "../data-table/data-table.component";
import {MatIconModule} from "@angular/material/icon";

export interface SrsPropertySectionDef extends SrsNodeBaseDef {
  ngClass?: NgClassType
}

export interface SrsPropertyPreviewRenderContext {
  propertyName: string
  propertyDef: SrsPropertyPreviewDef
  propertyValue: any
  objectValue: any
}

export interface SrsPropertyPreviewDef extends SrsNodeBaseDef<SrsPropertyPreviewRenderContext> {
  categoryName?: string
  valueRenderTemplate?: TemplateRef<SrsPropertyPreviewRenderContext>
}

export interface SrsPropertyRenderPreviewDef extends SrsPropertyPreviewDef {
  propertyName: string
  reflectedType: ReflectedType
}

export type SrsDataPreviewSectionOptions = { [id in string] : SrsPropertySectionDef }

export type SrsDataPreviewPropertyOptions = { [id in string] : SrsPropertyPreviewDef }

export interface SrsDataPreviewOptions {
  ngClass?: NgClassType
  properties?: SrsDataPreviewPropertyOptions
  sections?: SrsDataPreviewSectionOptions
}

export interface SrsDataPreviewState {
  reflectedType?: ReflectedType
  isArray?: boolean
  isComposite?: boolean
  sectionNames: string[]
  sectionDefs: { [id in string]: SrsPropertySectionDef }
  sectionProperties: { [id in string]: SrsPropertyRenderPreviewDef[] }
}

@Component({
  selector: 'data-preview',
  templateUrl: './data-preview.component.html',
  imports: [
    NgIf,
    NgClass,
    QuickPreviewPanelComponent,
    NgForOf,
    NgTemplateOutlet,
    JsonPipe,
    NgSwitch,
    NgSwitchCase,
    DatePipe,
    NgSwitchDefault,
    DataTableComponent,
    MatIconModule
  ],
  standalone: true
})
export class DataPreviewComponent implements OnInit, OnChanges {

  @Input() defaultSectionName = 'Primary Information'
  @Input() item?: any
  @Input() collapsible: boolean = false
  @Input() options:SrsDataPreviewOptions = {
  }

  state: SrsDataPreviewState = {
    sectionProperties: {},
    sectionDefs: {},
    sectionNames: [],
  }

  constructor(
    readonly reflector: ReflectorService,
    readonly cdr: ChangeDetectorRef) {

  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('item' in changes) {
      this.invalidateState()
    }
  }

  protected invalidateState() {
    const state: SrsDataPreviewState = {
      sectionProperties: {},
      sectionDefs: {},
      sectionNames: []
    }
    state.reflectedType = this.reflector.getReflectedType(this.item)
    state.isArray = this.reflector.isArray(this.item)
    state.isComposite = this.reflector.isComposite(this.item)

    this.state = state
    this.invalidateSections()
    this.cdr.detectChanges()
  }

  protected invalidateSections() {
    if (this.state.isArray) {

    }
    else if (this.state.isComposite) {

      const allSectionOptions = this.options.sections || {}
      const allPropertyOptions = this.options.properties || {}
      const nonHiddenPropertyNames: string[] = Object.getOwnPropertyNames(this.item)
        .filter(c => !allPropertyOptions[c] || !allPropertyOptions[c].hidden)

      Object.getOwnPropertyNames(allPropertyOptions).forEach(k => {
        if (!nonHiddenPropertyNames.includes(k)) {
          if (!allPropertyOptions[k].hidden) {
            nonHiddenPropertyNames.push(k)
          }
        }
      })

      nonHiddenPropertyNames.forEach(propertyName => {
        console.warn('----', propertyName)
        const propertyOption: SrsPropertyPreviewDef = allPropertyOptions[propertyName] || {}
        const category: string = propertyOption.categoryName || this.defaultSectionName
        if (!(category in this.state.sectionProperties)) {
          this.state.sectionProperties[category] = []
        }
        if (!this.state.sectionNames.includes(category)) {
          this.state.sectionNames.push(category)
          this.state.sectionDefs[category] = allSectionOptions[category] || {
            heading: category
          }
        }
        const renderItem: SrsPropertyRenderPreviewDef = Object.assign({
          propertyName: propertyName,
          reflectedType: this.reflector.getReflectedType(this.item[propertyName])
        }, propertyOption)
        this.state.sectionProperties[category].push(renderItem)
      })

      this.state.sectionNames = this.state.sectionNames
        .filter((c) => {
          const hidden: boolean = allSectionOptions[c] != null ? (allSectionOptions[c].hidden || false) : false
          return !hidden
        })
        .sort((a: string, b: string) => {
          const aOrder = allSectionOptions[a]?.order || 0
          const bOrder = allSectionOptions[b]?.order || 0
          return aOrder - bOrder
        })

      this.state.sectionNames.forEach(sectionName => {
        this.state.sectionProperties[sectionName] = this.state.sectionProperties[sectionName]
          .sort((a, b) => {

            const aOrder = a.order || 0
            const bOrder = b.order || 0
            return aOrder - bOrder
          })
      })
    }
  }
}
